import { Col, Flex, Row, Image, Space, Button } from 'antd';
import { useSelector } from 'react-redux';
import { Section, SectionTitle } from './styles';
import LineItem from '../../../../components/lineItem';
import { useTranslation } from 'react-i18next';
import { selectDraftTemplate } from '../../../../slices/templates';
import Tab from '../../../../components/tab';
import LinkedMachine from '../../components/linkedMachine';
import { useNavigate, useParams } from 'react-router';
import NotFound from '../../../../components/notFound';
import { ImageContainer } from '../../../../styles/commonStyles';

const TemplateDetails = () => {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  const navigate = useNavigate();

  const template = useSelector(selectDraftTemplate);

  const tabs = [
    {
      id: 1,
      title: 'Related machines',
      component: <LinkedMachine templateID={id} showSearch />,
    },
    {
      id: 2,
      title: 'Logs',
      component: <NotFound showButton={false} />,
    },
    {
      id: 3,
      title: 'Status',
      component: <NotFound showButton={false} />,
    },
  ];

  return (
    <Flex vertical gap={4}>
      <Section vertical gap={13}>
        <Flex justify="space-between">
          <SectionTitle>{t('template_information')}</SectionTitle>

          <Button type="primary" ghost onClick={() => navigate('edit')}>
            {t('edit')}
          </Button>
        </Flex>
        <Row gutter={[40, 16]}>
          <Col span={8}>
            <ImageContainer
              style={{
                width: '60%',
                minHeight: '60%',
              }}
            >
              <Image
                src={template?.images?.[0]?.url}
                preview={!!template?.images?.[0]?.url}
                fallback="/placeholder.png"
              />
            </ImageContainer>
          </Col>
          <Col span={16}>
            <Space direction="vertical" size={16}>
              <LineItem label={t('template')} value={template?.name} />
              <LineItem label={t('template_type')} value={template?.type} />
              <LineItem
                label={t('manufacturer')}
                value={template?.manufacturer}
              />
            </Space>
          </Col>
        </Row>
      </Section>
      <Tab tabs={tabs}></Tab>
    </Flex>
  );
};

export default TemplateDetails;
